import Pagination from '@Components/Common/Pagination';
import { ColumnType, DynamicTable } from '@Components/General/DynamicTable';
import { Box, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DisplayName } from '@Components/General/DynamicTable/Cells';
import ItemsPerPage from '@Components/General/ItemsPerPage';
import { Link as RouterLink, useNavigate } from '@tanstack/react-router';

// TODO: Implement shift select

const DonationId = ({ row }) => {
    return (
        <Link
            variant="bodyLarge"
            component={RouterLink}
            to={`${row.donation_id}`}
        >
            {row.donation_id}
        </Link>
    );
};

const TableHeader = ({ count, pageSize, setPageSize }) => {
    const { t } = useTranslation();
    return (
        <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography>{`${count.toLocaleString()} ${t(
                'Donations',
            )}`}</Typography>
            <ItemsPerPage
                label={t('Donations')}
                pageSize={pageSize}
                onChange={setPageSize}
            />
        </Box>
    );
};

function DonationsTable({
    donations,
    pageCount,
    page,
    setPage,
    pageSize,
    setPageSize,
    count,
    getSort,
    onSortChange,
    checkedDonations,
    setCheckedDonations,
    toggleCheckItem,
    additionalColumns = [],
}) {
    const { t } = useTranslation();
    // const location = useLocation();
    const navigate = useNavigate();

    // useEffect(() => {
    //     if (location.hash) {
    //         const element = document.getElementById(location.hash.slice(1));
    //         if (element) {
    //             element.scrollIntoView();
    //         }
    //     }
    // }, [location.hash]);

    const columns: ColumnType = [
        {
            name: t('Number'),
            field: 'donation_id',
            Component: DonationId,
        },
        {
            name: t('Donor'),
            sortField: 'name',
            field: 'donor',
            Component: DisplayName,
            contactIdField: 'donor.contact_id',
            nameField: 'donor.display_name',
        },
        {
            name: t('Date'),
            sortField: 'donation_date',
            field: 'donation_date',
            componentType: 'date',
        },
        {
            name: t('Donation Type'),
            sortField: 'donation_type',
            field: 'donation_type',
        },
        {
            name: t('Amount'),
            sortField: 'amount',
            field: 'donation_amount',
            componentType: 'currency_amount',
        },
        {
            name: t('Payments'),
            sortField: 'payments',
            field: 'donation_payments',
        },
        {
            name: t('Fundraiser'),
            sortField: 'fundraiser',
            field: 'fundraiser',
            Component: DisplayName,
            contactIdField: 'fundraiser.contact_id',
            nameField: 'fundraiser.display_name',
        },
        {
            name: t('Notes'),
            sortField: 'donor_note',
            field: 'donor_note',
        },
        ...additionalColumns,
    ];

    return (
        <>
            <DynamicTable
                {...(pageSize
                    ? {
                          tableHeader: (
                              <TableHeader
                                  pageSize={pageSize}
                                  setPageSize={setPageSize}
                                  count={count}
                              />
                          ),
                      }
                    : {})}
                columns={columns}
                rows={donations || []}
                checkField="donation_id"
                checkedRows={checkedDonations}
                setCheckedRows={setCheckedDonations}
                toggleCheck={toggleCheckItem}
                getSort={getSort}
                onSortChange={onSortChange}
                rowProps={row => ({
                    onClick: () =>
                        navigate({ to: `/donations/${row.donation_id}` }),
                })}
            />
            <Pagination
                sx={{ mt: '2rem' }}
                pageCount={pageCount}
                page={page}
                onChange={setPage}
            />
        </>
    );
}

export default DonationsTable;
